import { render } from "./UserPostListPage.vue?vue&type=template&id=62edfa07"
import script from "./UserPostListPage.vue?vue&type=script&lang=ts"
export * from "./UserPostListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script